import tw from 'tailwind-styled-components'

export const TwMainContainer = tw.div<{$fullscreen: boolean}>`
${p =>
  p.$fullscreen
    ? `z-1000 absolute top-0 left-0 w-100vw h-100vh bg-main-old`
    : 'h-auto'}
`

export const TwFullscreenContainer = tw.div<{$fullscreen: boolean}>`
${p =>
  p.$fullscreen &&
  `
    border-0
    border-t-1
    border-split-old
    border-solid
    mt-64
    overflow-y-auto
    `}
`

export const TwTaskTitle = tw.div`
  mr-auto
  text-18
  leading-6
`

export const TwEditorContainer = tw.div<{$fullscreen?: boolean}>`
  ${p => !p.$fullscreen && `px-0`}
  overflow-y-auto
  overflow-x-hidden
`

export const TwHistoryLeftSideContainer = tw.div`
  flex
  flex-col
  w-full
  max-w-680
  border-split-old
  border-0
  border-r-1
  border-solid
  bg-main-old
`

export const TwHistoryFooter = tw.div`
  h-64
  min-h-64
  flex gap-8
  items-center
  pl-24
  pr-24
`

export const TwHistoryListContainer = tw.div`
  w-280
  overflow-y-auto
  bg-main-old
`

export const TwHistoryItemContainer = tw.div``

export const TwHistoryUserContainer = tw.div<{$type: 'first' | 'middle'}>`
  flex items-center gap-4
  h-20
  pl-16
  cursor-default
  mb-6
  ${p => p.$type === 'first' && 'mt-18'}
  ${p => p.$type === 'middle' && 'mt-26'}
`

export const TwHistoryUser = tw.div`
  leading-5
  text-12
`

export const TwHistoryDateContainer = tw.div<{$selected?: boolean}>`
  py-8
  cursor-pointer
  ${p => p.$selected && 'bg-action-default'}
`

export const TwHistoryDate = tw.div<{$selected?: boolean}>`
  pl-40
  ${p => !p.$selected && 'text-third-old'}
  ${p => p.$selected && 'text-on-color'}
  text-14
  leading-4
`

export const TwEmptyHistoryContainer = tw.div`
  h-full
  flex
  items-center
  justify-center
`
export const TwEmptySmallContainer = tw.div`
  flex
  flex-col
  items-center
  justify-center
  mx-auto
  gap-16
  pt-16
  w-304
`
export const TwEmptyImage = tw.div`
  w-240
  h-128
`
export const TwEmptyLabel = tw.div`
  text-18
  leading-6
  font-semibold
  text-third-old
`
export const TwEmptyHistoryHint = tw.div`
  w-224
  max-w-224
  text-center
  text-14
  leading-4
  font-normal
  text-third-old
`

export const TwEmptyDescContainer = tw.div`
  h-full
  pt-172
`

export const TwEmptyDescHint = tw.div`
  w-272
  max-w-272
  text-center
  text-14
  leading-4
  font-normal
  text-third-old
`
